<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-5">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>View Client Email</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
    
          </vs-col>
        </vs-row>
        <vs-divider class="m-5" />
        <div class="vx-row mb-6" v-if="client_email.client_id">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >
              Client:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ client_email.client_name }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="client_email.user_id"
        >
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >
              User:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ client_email.elomark_user_name }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="client_email.username">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >
              Username:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ client_email.username }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="client_email.email">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >
              Email:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ client_email.email }}
          </div>
        </div>
               <div class="vx-row mb-6" v-if="client_email.status">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >
              Status:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ client_email.status['value'] }}
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
// Store Module
import axios from "@/axios.js";
import defineAbilitiesFor from '@/config/abilities'
import moduleClientsManagement from "@/store/clients-management/moduleClientsManagement.js";
export default {
  data() {
    return {
          abilities : null,

       client_email : {
         client_id:null,
         elomark_user_id : null,
         username : null,
         email:null,
         password : null,
         status : {
        name:'Live',
        value: 'Live'
      }
  }
    } 
  },
  components: {
  },
  created() {
        var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });
    if (!moduleClientsManagement.isRegistered) {
      this.$store.registerModule(
        "clientsManagement",
        moduleClientsManagement
      );
      moduleClientsManagement.isRegistered = true;
    }
    this.init();
  },
  watch: {
   
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let clientEmailId = this.$route.params.clientEmailId;
    this.$store
      .dispatch("clientsManagement/fetchClientEmail", clientEmailId)
      .then(res => {
          this.client_email = res.data
          let email_status = {}
          email_status.name = this.client_email.status
          email_status.value = this.client_email.status
          this.client_email.status = email_status

          console.log(this.client_email)
      })
    },
    goBack: function() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
